import { TOAST_EXPIRED, TOAST_SPAWNED } from '../../action-types';
import createAction from '../../create-action';

export const toastSpawned = createAction(TOAST_SPAWNED);

export const toastExpired = createAction(TOAST_EXPIRED);
